import React, { Fragment, useState } from 'react';
import { UPDATE } from 'ra-core';
import { Button, useDataProvider, useTranslate, useRecordContext, useRefresh } from 'react-admin';
import MUIButton from '@mui/material/Button';
import HistoryIcon from '@mui/icons-material/History';
import ErrorIcon from '@mui/icons-material/Error';
import CheckIcon from '@mui/icons-material/CheckCircle';
import { useSnackbar } from 'notistack'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function ResetCheck() {
    const [isOpen, setIsOpen ] = useState(false);
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const {enqueueSnackbar} = useSnackbar();
    const record = useRecordContext();
    const refresh = useRefresh();

    const handleClick = () => {
        setIsOpen(true);
    }

    const handleDialogClose = () => {
        setIsOpen(false);
    };

    const handleConfirm = async () => {
        setIsOpen(false);
        let device = [record];

        let updateProps = {
            id: device[0].id,
            data: {
                status: {
                    codice: '3',
                },
                status_regman: {
                    codice: '0'
                },
                $unset: {
                    anomalia: '',
                    impianto_regman: '',
                    install_regman_at: '',
                    serial_number_cpe: '',
                    wr_collaudo_one: '',
                    impianto_collaudo_one: '',
                    data_collaudo_one: '',
                    status_collaudo_one: ''
                }
            },
            previousData: device
        };

        await dataProvider(UPDATE, 'devices', updateProps).then(result => {
            if (result.data.error) {
                enqueueSnackbar(translate('tim.resetCheck.error'), {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    },
                    autoHideDuration: 3000,
                });
            }
            else if (result.data.message && result.data.message === "Updated") {
                enqueueSnackbar(translate('tim.resetCheck.updated'), {
                    variant: 'success',
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    },
                    autoHideDuration: 3000,
                });
            }
            refresh();
        }).catch(error => {
            enqueueSnackbar(translate('tim.resetCheck.error'), {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                },
                autoHideDuration: 3000,
            });
        });
    };

    return (
        <Fragment>
            <MUIButton label='tim.resetCheck.button_label' onClick={handleClick} color="secondary">
                <HistoryIcon />
                {translate('tim.resetCheck.button_label')}
            </MUIButton>
            <Dialog
                open={isOpen}
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{translate('tim.resetCheck.title', { name: record.serial_number_tim })}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {translate('tim.resetCheck.content')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} label='tim.resetCheck.cancel' color="primary" autoFocus>
                        <ErrorIcon />
                    </Button>
                    <Button onClick={handleConfirm} label='tim.resetCheck.confirm' color="primary" autoFocus>
                        <CheckIcon />
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}

// ResetCheck.propTypes = {
//     dataProvider: PropTypes.func.isRequired
// };

export default ResetCheck;